"use strict";

/* General + Third-Party */
import jQuery from 'jquery';
import { lazyload } from './globals/lazyload';
import Alpine from 'alpinejs';
import Masonry from 'masonry-layout';

// Access Apline function to the window object
window.Alpine = Alpine
window.Masonry = Masonry;

/* Layout-Parts */
import { navigationSubNav } from './layout/navigation';

/* Blocks */
import { masonryBlogTeaser } from '../../blocks/blog-teaser/script';
import { kkVideoPlain } from '../../blocks/image-video/script';


jQuery(document).ready(_ => {
  // General + Third-Party
  Alpine.start();
  lazyload();

  //Layout-Parts
  navigationSubNav();


  //Blocks
  masonryBlogTeaser();
  kkVideoPlain();
});
